import { render, staticRenderFns } from "./HtmlReadOnlyField.vue?vue&type=template&id=58299ab4&scoped=true"
import script from "./HtmlReadOnlyField.vue?vue&type=script&lang=ts"
export * from "./HtmlReadOnlyField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58299ab4",
  null
  
)

export default component.exports